export default __webpack_public_path__ + "static/media/service.f402cad7.md";